import loaderImg from "../../assets/images/loader.gif";

export const Loader = () => {
  return (
    <div className="LoaderMain">
      <img loading="lazy" src={loaderImg} alt="reload page" />
    </div>
  );
};
